module.exports = "https://www.gc-qa.gnp.com.mx/fac466af377730c824991ae233fabf86.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/carrusel-03.gif
// module id = 8072
// module chunks = 0